import React from 'react';
import GuestPicker from '@homeaway/react-guest-picker';
import {SVGIcon} from '@homeaway/react-svg';
import {GROUP__24} from '@homeaway/svg-defs';

const getGuestLabel = (labels, numGuests, pet) => {
    const petString = pet ? `, ${labels.pets}` : '';
    const defaultString =
        numGuests > 1
            ? `${numGuests} ${labels.guests}${petString}`
            : `${labels.guests}${petString}`;

    switch (numGuests) {
        case 0:
            return '';

        case 1:
            return `1 ${labels.guest || labels.guests}${petString}`;

        default:
            return defaultString;
    }
};

const getLabel = (singularLabel, pluralLabel, count) =>
    count === 1 ? `${count} ${singularLabel}` : `${count} ${pluralLabel}`;

function GuestPickerComponent({
    adultsCount,
    childrenCount,
    petIncluded,
    messages,
    ...props
}) {
    const inputIcon = <SVGIcon markup={GROUP__24} />;

    const formSuffixElement = petIncluded ? messages.petMessage : '';

    return (
        <div className="DSM__guest">
            <GuestPicker
                label={messages.label}
                name={'Guests'}
                guestLabel={getGuestLabel(
                    messages,
                    adultsCount + childrenCount,
                    petIncluded
                )}
                applyButtonLabel={messages.applyBtn}
                modalTitle={messages.modalTitle}
                continueButtonLabel={messages.mobileBtn}
                adultsLabel={getLabel(
                    messages.adult,
                    messages.adults,
                    adultsCount
                )}
                adultsCount={adultsCount}
                childrenLabel={getLabel(
                    messages.child,
                    messages.children,
                    childrenCount
                )}
                childrenCount={childrenCount}
                petIncluded={petIncluded}
                petLabel={messages.pets}
                petYesLabel={messages.yesBtn}
                petNoLabel={messages.noBtn}
                showPetOption
                inputIcon={inputIcon}
                id={'search-modal-guest-picker'}
                ageData={[]}
                formSuffixElement={formSuffixElement}
                placement="bottom"
                {...props}
            />
        </div>
    );
}

export default GuestPickerComponent;
